import * as Yup from "yup";

const PatientPersonalInfoValidation = Yup.object().shape({
  firstName: Yup.string()
    .required("First name is required!")
    .test(
      "no-empty-blank-space",
      "First name cannot be an empty blank space(s)",
      (value: any) => {
        return value && value.trim() !== "";
      }
    ),
  lastName: Yup.string()
    .required("Last name is required!")
    .test(
      "no-empty-blank-space",
      "Last name cannot be an empty blank space(s)",
      (value: any) => {
        return value && value.trim() !== "";
      }
    ),
  middleInitial: Yup.string(),
  gender: Yup.string()
    .required("Sex at Birth is required")
    .test(
      "no-empty-blank-space",
      "Sex at Birth cannot be an empty blank space(s)",
      (value: any) => {
        return value && value.trim() !== "";
      }
    ),
  birthDate: Yup.string().required("Date of Birth is required!"),
});

export default PatientPersonalInfoValidation;
